var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconLinkedin2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 79,
    height: 79,
    viewBox: "0 0 79 79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_10.Linkedin",
    "data-name": "10.Linkedin",
    d: "M39.5,0A39.5,39.5,0,1,0,79,39.5,39.5,39.5,0,0,0,39.5,0ZM28.014,60.289H19.4V32.53h8.617ZM23.7,28.741A5.015,5.015,0,1,1,28.695,23.7,5.015,5.015,0,0,1,23.7,28.741ZM60.289,60.289H51.677V46.776c0-3.222-.062-7.354-4.48-7.354s-5.2,3.5-5.2,7.12V60.289H33.419V32.53h8.269v3.784h.12a9.05,9.05,0,0,1,8.155-4.485c8.721,0,10.327,5.748,10.327,13.212Z",
    fill: "#c6c6c6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLinkedin2);
export default __webpack_public_path__ + "static/media/icon-linkedin-2.135debc9139194b8f4373e6be116a5e1.svg";
export { ForwardRef as ReactComponent };